var _path, _path2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpgradeTest(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.05273 0.25H18.9473C21.5997 0.25 23.75 2.40031 23.75 5.05273V18.9473C23.75 21.5997 21.5997 23.75 18.9473 23.75H5.05273C2.40031 23.75 0.25 21.5997 0.25 18.9473V5.05273C0.25 2.40031 2.40031 0.25 5.05273 0.25Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.05273 0.25H18.9473C21.5997 0.25 23.75 2.40031 23.75 5.05273V18.9473C23.75 21.5997 21.5997 23.75 18.9473 23.75H5.05273C2.40031 23.75 0.25 21.5997 0.25 18.9473V5.05273C0.25 2.40031 2.40031 0.25 5.05273 0.25Z",
    stroke: "#FAE0BC",
    strokeWidth: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10647_96943)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5449 6.27246L17.3203 10.6328C17.8354 11.4427 18.1074 12.3789 18.1074 13.3389C18.1072 15.3041 16.5097 16.9022 14.5449 16.9043V16.9053L14.543 16.9043H14.541C12.5763 16.9021 10.9787 15.304 10.9785 13.3389C10.9785 12.3789 11.2515 11.4427 11.7666 10.6328L14.541 6.27246V6.2666L14.543 6.26953L14.5449 6.2666V6.27246Z",
    fill: "#714FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.34082 6.65137V9.32617L7.12109 9.9082L7.11133 9.90527L4.88477 9.32617V6.65137H9.34082Z",
    fill: "#FFEACC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.34082 14.6768V17.3516C9.34063 18.5805 8.34095 19.5798 7.1123 19.5801L7.11133 19.5771C5.88359 19.5758 4.88489 18.5779 4.88477 17.3496V14.6748L6.67285 14.3301L6.66602 14.2471L7.19824 14.2305L9.34082 14.6768Z",
    fill: "#FFEACC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.3584 9.3252V14.6748H4.88477V9.3252H9.3584Z",
    fill: "#714FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.12287 11.5547H4.88477V10.6631H7.12287L7.24874 11.1089L7.12287 11.5547Z",
    fill: "#FFEACC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.88477 12.4463H6.66805V13.3379H4.88477V12.4463Z",
    fill: "#FFEACC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8785 12.7432V13.6348H14.9868V14.5265H14.541V11.8516H14.9868V12.7432H15.8785Z",
    fill: "#FFEACC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5406 11.8516V14.5265H14.0948V13.6348H13.2031V12.7432H14.0948V11.8516H14.5406Z",
    fill: "#FFEACC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.07129 7.0957H3.99121V4.4209H6.07129V7.0957ZM10.2314 4.4209V7.0957H6.07324V4.4209H10.2314Z",
    fill: "#714FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.11914 10.6631H7.55596V11.5547H7.11914V10.6631Z",
    fill: "#FFEACC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10647_96943"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.1579,
    height: 15.1579,
    fill: "white",
    transform: "translate(4.4209 4.4209)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpgradeTest);
export default __webpack_public_path__ + "static/media/upgrade-test.2bcae50049e6a66ea7df8057dfbf50b2.svg";
export { ForwardRef as ReactComponent };